import { Directive, inject, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl, ValidationErrors } from '@angular/forms';

import { ValidationMessages } from 'app/shared/models/validation-messages.model';

@Directive()
export abstract class BaseControlDirective<TModel> implements ControlValueAccessor, OnInit {
  private readonly injector = inject(Injector);

  @Input() public validationMessages: ValidationMessages = {};
  @Input() public disabled = false;

  public set model(value: TModel | undefined | null) {
    this.modelValue = value;
    this.modelChanged();
  }

  public get model(): TModel | undefined | null {
    return this.modelValue;
  }

  public modelValue: TModel | undefined | null;
  public onModelChange!: (_: any) => void;
  public onModelTouched!: any;
  public control!: NgControl;

  public ngOnInit(): void {
    this.control = this.injector.get<NgControl>(NgControl);
  }

  public modelChanged(): void {
    if (this.onModelChange !== null && this.onModelChange !== undefined) {
      this.onModelChange(this.model);
    }
  }

  public writeValue(model: TModel | undefined | null): void {
    this.modelValue = model;
  }

  public registerOnChange(fn: (_: any) => void): void {
    this.onModelChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  public isInvalid(): boolean {
    return !!this.control.touched && !!this.control.invalid;
  }

  public getErrorMessages(errors: ValidationErrors | null): string[] {
    const validationErrorKeys = errors ? Object.keys(errors) : [];

    return validationErrorKeys
      .map((errorKey) => this.validationMessages[errorKey] || '')
      .filter((value) => !!value);
  }

  public onBlur(): void {
    if (this.onModelTouched !== null && this.onModelTouched !== undefined) {
      this.onModelTouched();
    }
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
